import request from '../../../helpers/request';

const changeHouseBalance = async (houseId, values) => {
  const response = await request.put(
    `/HousingStock/house/${houseId}/balance`,
    values,
    'При изменении баланса произошла ошибка'
  );

  return response;
};

export default changeHouseBalance;
